<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    :id="id"
    :class="`shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] rounded-md border-solid border-[#EFF0F1] tw-max-h-[100%] tw-overflow-auto tableWrapper ${customClass}`"
  >
    <table
      :class="`tw-min-w-full tw-divide-y tw-divide-gray-200 table ${
        isStandardRow ? 'table-default' : ''
      }`"
    >
      <thead class="tw-sticky tw-top-0 tw-z-[1]">
        <tr
          :class="`tw-bg-[#FFF] tw-h-[44px] table-row !tw-border-0 ${headerWrapperClass}`"
        >
          <th v-if="draggable" class="!tw-w-[1px] table-header"></th>
          <th
            v-if="showCheckboxRow"
            class="tw-min-w-[37px] !tw-mr-[22px] tw-py-3 tw-px-4 tw-text-sm tw-text-gray-700 table-header"
          >
            <custom-check-box
              :class="`tw-h-[20px] !tw-mb-0 ${draggable ? '!tw-pl-0' : ''}`"
              size="20px"
              :color-checkmark="colorCheckmark"
              :is-checked="selectAll"
              @update:is-checked="(value) => onSelectAllChanged(value)"
            />
          </th>
          <th
            v-for="(column, index) in columns"
            :key="column.value"
            :class="`tw-py-3 tw-px-4 tw-text-sm tw-text-gray-700 table-header tw-pr-10 ${
              index === 1 ? 'th-two' : ''
            }`"
          >
            <span
              :class="[
                `tw-flex tw-item-center tw-gap-[4px] tw-select-none tw-items-center`,
                column.headerClass ? column.headerClass : '',
                column.sortable ? 'tw-cursor-pointer' : '',
                columnActive === index
                  ? `!tw-text-[${textHeaderSortActiveDefault}]`
                  : `!tw-text-[${textHeaderDefault}]`,
              ]"
              @click="clickSortHeader(column, index)"
            >
              <span class="tw-w-[max-content]">
                {{ column.text }}
              </span>
              <span v-if="column.sortable">
                <SwapIcon
                  :color="
                    columnActive === index
                      ? textHeaderSortActiveDefault
                      : textHeaderDefault
                  "
                />
              </span>
            </span>
          </th>
        </tr>
      </thead>
      <tbody v-if="!isLoading && data?.length">
        <template
          v-for="(item, idx) in sortedData"
          :key="`${dataType}-${item.id}`"
        >
          <tr
            :class="`table-row ${
              item.id === idItemExpland ? 'row-expaned' : ''
            } ${
              isStandardRow && selectedRows.includes(item.id)
                ? 'selected-row'
                : ''
            }`"
            :style="`background-color: ${
              selectedRows.includes(item.id) ? '#F2F8FF' : item.rowBgColor || ''
            }`"
            @mouseover="hoveringRowId = item.id"
            @mouseleave="hoveringRowId = ''"
          >
            <td
              v-if="draggable"
              :class="`tw-w-[18px] table-data tw-cursor-pointer !tw-pr-[10px] !tw-pb-[20px] ${
                heightTb ? ' tw-h-[56px] table__data' : 'tw-h-[64px]'
              }`"
            >
              <DraggableIcon />
            </td>

            <td
              v-if="showCheckboxRow"
              :class="`!tw-w-[30px] tw-py-3 tw-px-4 tw-text-sm tw-text-gray-700 table-data tw-h-[64px] ${
                heightTb ? ' tw-h-[56px] table__data' : 'tw-h-[64px]'
              } ${isShowHoverBg(item.id) ? hoverBgColor : ''} ${
                item?.checklistGroupCompletionPcnt === 1
                  ? '!tw-bg-[#EFF0F180]'
                  : ''
              } ${
                idItemExpland === item.id || selectedRows.includes(item.id)
                  ? extendActiveBgColor
                  : ''
              }`"
            >
              <custom-check-box
                :id="item.id"
                class="!tw-mb-0 tw-h-[20px] !tw-pl-0"
                size="20px"
                :color-checkmark="colorCheckmark"
                :is-checked="selectedRows.includes(item.id)"
                @update:is-checked="() => toggleRow(item.id, item)"
              />
            </td>
            <td
              v-for="column in columns"
              :key="column.value"
              :class="`tw-py-3 tw-px-4 ${
                column.font13 ? 'tw-text-[13px]' : 'tw-text-[14px]'
              } ${column.textAlign ? 'table__data' : ''}   
                tw-text-gray-700 ${
                  column.valueClass ? column.valueClass : ''
                } table-data  ${isShowHoverBg(item.id) ? hoverBgColor : ''} ${
                  item?.checklistGroupCompletionPcnt === 1
                    ? '!tw-bg-[#EFF0F180]'
                    : ''
                } ${
                  idItemExpland === item.id || selectedRows.includes(item.id)
                    ? extendActiveBgColor
                    : ''
                }`"
              @click="onClickItem(item, column)"
            >
              <slot
                :name="'cell(' + column.value + ')'"
                :value="item[column.value]"
                :idx="idx"
                :item="item"
              >
                <template v-if="typeof column.render === 'function'">
                  <span
                    class="tw-flex tw-w-[max-content]"
                    @click="getAttachment(item)"
                    v-html="
                      getSafeHTML(
                        column.value === '*'
                          ? column.render(item)
                          : column.render(item[column.value]),
                      )
                    "
                  />
                </template>
                <template v-else>
                  {{ item[column.value] }}
                </template>
              </slot>
            </td>
          </tr>
          <!-- detail -->
          <tr v-if="item.id === idItemExpland" class="detail">
            <td :colspan="columns.length + 2" class="detail_content">
              <slot
                :name="'detail'"
                :item="item"
                :value="item.id === idItemExpland"
              >
              </slot>
            </td>
          </tr>
        </template>
      </tbody>
      <!-- List empty -->
      <tbody v-if="!isLoading && !data?.length">
        <tr class="tr-empty">
          <td :colspan="showCheckboxRow ? columns.length + 1 : columns.length">
            <div
              class="tw-w-full tw-text-[#878787] tw-text-[14px] tw-text-center"
            >
              <span>{{ emptyText || "" }}</span>
            </div>
          </td>
        </tr>
      </tbody>

      <!-- skeleton loading -->
      <tbody v-if="isLoading">
        <TableSkeleton
          :rows-number="skeletonRowNumber"
          :columns-number="
            columns.length + (draggable ? 1 : 0) + (showCheckboxRow ? 1 : 0)
          "
        />
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import Utils from "@/utils/utilities";
import CustomCheckBox from "@/components/common/customCheckBox.vue";
import TableSkeleton from "@/components/common/skeleton/tableSkeleton.vue";
import DraggableIcon from "@/components/svgs/draggableIcon.vue";
import SwapIcon from "@/components/svgs/swapIcon.vue";
import store from "@/store";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { computed } from "vue";

export type CustomTableColumn = {
  text: string;
  value: string;
  sortable?: boolean;
  headerClass?: string;
  valueClass?: string;
  render?: any;
  sortDefault?: boolean;
  font13?: boolean;
  textAlign?: boolean;
  headerWrapperId?: string;
  isActiveClick?: boolean;
};

@Component({
  components: {
    CustomCheckBox: CustomCheckBox,
    TableSkeleton: TableSkeleton,
    DraggableIcon: DraggableIcon,
    SwapIcon: SwapIcon,
  },
})
export default class CustomTable extends Vue {
  @Prop({ type: Array, required: true })
  columns!: CustomTableColumn[];

  @Prop({ type: Array, required: true })
  data!: Array<any>;

  @Prop({ default: false })
  isAccessible!: boolean;

  @Prop({ type: String, required: false })
  emptyText?: string;

  @Prop({ type: Boolean, required: false, default: false })
  isLoading?: boolean;

  @Prop({ required: false, default: null })
  idItemExpland?: any;

  @Prop({ required: false, default: false })
  draggable?: boolean;

  @Prop({ required: false, default: "" })
  headerWrapperClass?: string;

  @Prop({ required: false, default: true })
  showCheckboxRow?: boolean;

  @Prop({ required: false, default: "desc" })
  sortDirection = "desc";

  @Prop({ required: false, default: false })
  questionBeforeSort?: boolean;

  @Prop({ required: false, default: undefined })
  toSorted?: (sortColumnBy: string, sortDirections: string) => Array<any>;

  @Prop({ required: false, default: "" })
  selectedChildrenIdsKey = "";

  @Prop({ required: false, default: "#387dff" })
  readonly colorCheckmark: string = "";

  @Prop({ required: false, default: 3 })
  skeletonRowNumber?: number;

  @Prop({ required: false, default: false })
  heightTb?: boolean;

  @Prop({ required: false, default: "" })
  customClass?: string;

  @Prop({ required: false, default: false })
  isStandardRow?: string;

  @Prop({ required: false, default: "" })
  id?: string;

  @Prop({ required: false, default: false })
  hoverBgColor?: string;

  @Prop({ required: false, default: false })
  extendActiveBgColor?: string;

  @Prop({ required: false, default: "" })
  detailHoveringId?: string | number;

  @Prop({ required: false, default: "" })
  dataType?: string;

  selectedRows: Array<number> = [];
  selectAll = false;
  columnActive = -1;
  sortColumnBy = "";
  textHeaderDefault = "#878787";
  textHeaderSortActiveDefault = "#211F58";
  sortDirections = this.sortDirection;
  hoveringRowId: string | number = "";

  mounted() {
    const columnIndex = this.columns.findIndex((i) => i.sortDefault === true);
    columnIndex >= 0 && (this.columnActive = columnIndex);
    columnIndex >= 0 && (this.sortColumnBy = this.columns[columnIndex].value);
    EventEmitter.on(
      EmitterEvents.CLICK_SORT_COLUMN_ACTION_TABLE,
      (emitData: any) => {
        if (this.questionBeforeSort) {
          if (!emitData.column.sortable) return;
          this.columnActive = emitData?.index;
          this.sortColumn(emitData.column.value);
        }
      },
    );
    EventEmitter.on(EmitterEvents.REMOVE_ITEM_SELECTED_ROW, () => {
      this.selectedRows = [];
      this.selectAll = false;
    });
  }

  beforeDestroy() {
    EventEmitter.off(EmitterEvents.CLICK_SORT_COLUMN_ACTION_TABLE);
  }

  get sortedData() {
    const data = [...this.data];
    if (this.toSorted) {
      return data;
    }
    if (this.sortColumnBy && this.sortDirections) {
      const isAscending = this.sortDirections === "asc";
      data.sort((a, b) => {
        const valueA = a[this.sortColumnBy];
        const valueB = b[this.sortColumnBy];
        if (typeof valueA === "string" && typeof valueB === "string") {
          return isAscending
            ? valueA.localeCompare(valueB)
            : valueB.localeCompare(valueA);
        }
        return isAscending ? valueA - valueB : valueB - valueA;
      });
    }
    return data;
  }

  onSelectAllChanged(value: boolean) {
    this.selectedRows = value ? this.data.map((item) => item.id) : [];
    this.selectAll = value;
  }

  @Watch("selectedRows")
  onSelectedRowsChanged() {
    this.$emit("update-selected-rows", this.selectedRows);
  }

  getSafeHTML(htmlText: string) {
    return Utils.sanitizeHTML(htmlText);
  }

  public defaultUiText = computed(
    () => store.state.LanguagePicker.defaultUiText,
  );

  public languageSelectedText = computed(
    () => store.state.LanguagePicker.languageSelectedText,
  );

  isShowHoverBg(itemId: number | string) {
    return (
      this.hoverBgColor &&
      (this.hoveringRowId === itemId || this.detailHoveringId === itemId)
    );
  }

  getUiText = (id: string, isArray = false) => {
    return Utils.getUiText(
      id,
      this.languageSelectedText.value,
      this.defaultUiText.value,
      isArray,
    );
  };

  onClickItem(item: any, column: CustomTableColumn) {
    this.$emit("clicked-row", item, column);
  }

  clickSortHeader(column: CustomTableColumn, index: number) {
    if (!column?.sortable) return;
    this.$emit("clickSortColumn", column, index);
    if (!this.questionBeforeSort) {
      this.columnActive = index;
      this.sortColumn(column.value);
    }
  }

  sortColumn(column) {
    if (column === this.sortColumnBy) {
      this.sortDirections = this.sortDirections === "asc" ? "desc" : "asc";
    } else {
      this.sortColumnBy = column;
      this.sortDirections = "asc";
    }
    this.toSorted?.(this.sortColumnBy, this.sortDirections);
  }

  getAttachment(item) {
    this.$emit("currentImage", item);
  }
  toggleRow(rowId: number, item: any) {
    const index = this.selectedRows.indexOf(rowId);
    if (index > -1) {
      // unselected
      this.selectedRows.splice(index, 1);

      // unselected children
      const loop = (arr: any[]) => {
        arr?.forEach((child) => {
          if (child.id) {
            const i = this.selectedRows.indexOf(child.id);
            if (i > -1) {
              this.selectedRows.splice(i, 1);
            }
            loop(child[this.selectedChildrenIdsKey]);
          }
        });
      };
      loop(item[this.selectedChildrenIdsKey]);

      // unselected parents
      item?.checklistItemPathId?.forEach((id) => {
        const i = this.selectedRows.indexOf(id);
        if (i > -1) {
          this.selectedRows.splice(i, 1);
        }
      });

      // unselected all
      this.selectAll = false;
      this.$emit("update-selected-rows", this.selectedRows);
      return;
    }

    // selected
    this.selectedRows.push(rowId);

    // selected children
    const loop = (arr: any[]) => {
      arr?.forEach((child) => {
        if (child.id && !this.selectedRows.includes(child.id)) {
          this.selectedRows.push(child.id);
          loop(child[this.selectedChildrenIdsKey]);
        }
      });
    };
    loop(item[this.selectedChildrenIdsKey]);

    // selected parent
    if (item.orderNumber) {
      const arrId = `${item.orderNumber}`.split(".");
      const loop = () => {
        arrId.pop();
        if (arrId.length) {
          const parentId = arrId.join(".");
          const parent = this.data.find(
            (item) => item.orderNumber === parentId,
          );
          const isSelectedAll = parent?.[this.selectedChildrenIdsKey]?.every(
            (child: any) => this.selectedRows.includes(child.id),
          );
          if (isSelectedAll && parent?.id) {
            this.selectedRows.push(parent.id);
          }
          loop();
        }
      };
      loop();
    }

    // selected all
    if (this.selectedRows.length === this.data.length) {
      this.selectAll = true;
    }

    this.$emit("update-selected-rows", this.selectedRows);
  }
}
</script>

<style scoped lang="scss">
/* // .table * {
//   border: none;
// } */

.tableWrapper {
  background: #ffffff;
  width: 100%;
  border-radius: 6px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
  border: 1px solid #eff0f1 !important;
}

.table {
  display: table;
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0px;
  thead {
    tr {
      th {
        background-color: #fcfcfd;
        &:first-child {
          border-top-left-radius: 6px;
        }
        &:last-child {
          border-top-right-radius: 6px;
        }
      }
    }
  }
  tr {
    &.table-row {
      border-bottom: 1px solid #eff0f1;
    }
  }
  &.table-default {
    tr {
      &:hover {
        td {
          background-color: #f2f8ff80;
        }
      }
      &.selected-row {
        td {
          background-color: #f2f8ff80;
        }
      }
    }
  }
}

.table-header {
  padding-top: 0.5px;
  padding-bottom: 0.5px;
  vertical-align: middle;
  max-height: 40px;
  padding-left: 0px;
  padding-right: 17px;
}

.table-header:first-child {
  padding-left: 25px;
  padding-right: 0px;
}
.table-row {
  display: table-row;
  border-bottom: 1px solid #eff0f1;
}

.detail {
  border-top: 1px solid #eff0f1;
}

.detail_content {
  padding: 0px;
}

.table-data {
  /* display: table-cell;
  padding: 10px; Adjust the padding as needed */
  padding-right: 40px;
  vertical-align: middle;
  padding: 18px 15px;
  padding-left: 0px;
  /* line-height: 100%; */
}

.table-data:first-child {
  padding-left: 25px;
  padding-right: 0px;
}
.table__data:first-child {
  padding-left: 9px;
  padding-right: 0px;
}
.table__data {
  text-align: center;
}
.tr-empty {
  height: 56px;
}
.tr-empty td {
  vertical-align: middle;
}
.road-map-table {
  .table-header {
    padding-right: 45px;
  }
  .table-data:not(:last-child) {
    padding-right: 45px;
  }
  .table tbody tr:nth-of-type(even) {
    background-color: #fcfcfd;
  }
  .table tbody tr:nth-of-type(odd) {
    background-color: #ffffff;
  }
}

.inciden-event-header {
  overflow: unset !important;
  .table-data {
    padding-top: 13px;
    padding-bottom: 13px;
  }
  .table-data:not(:last-child) {
    padding-right: 14px !important;
  }
  .table-data:last-child {
    padding-left: 0px !important;
  }
  .tr-empty {
    height: 70px;
  }
}

@media print {
  table,
  tr,
  td,
  th {
    border: none !important;
    border-spacing: 0;
  }
  table {
    thead {
      background-color: #211f58 !important;
      tr {
        background-color: #211f58 !important;
      }
      th {
        background-color: #211f58 !important;
        border-color: #211f58;
      }
    }
    .table-header {
      box-shadow: none !important;
      -webkit-box-shadow: none !important;
      -moz-box-shadow: none !important;
    }
  }
}
</style>
